/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Pc_Alt_Col_LicenseInputs */

const en_pc_alt_col_license = /** @type {(inputs: Pc_Alt_Col_LicenseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`License`)
};

const zh_pc_alt_col_license = /** @type {(inputs: Pc_Alt_Col_LicenseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`许可证`)
};

/**
* | output |
* | --- |
* | "License" |
*
* @param {Pc_Alt_Col_LicenseInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const pc_alt_col_license = /** @type {((inputs?: Pc_Alt_Col_LicenseInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pc_Alt_Col_LicenseInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_pc_alt_col_license(inputs)
	return zh_pc_alt_col_license(inputs)
});
export { pc_alt_col_license as "pc.alt.col.license" }